/* ════════════════════════════════════════════════════════════
   SUMA · Paginación AJAX para blog del home
   Intercepta clicks en paginación y carga sin recargar página
   ════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  function initBlogAjaxPagination() {
    const blogSection = document.querySelector('.ecom-shopify__blog');
    if (!blogSection) return;

    // Delegación de eventos: capturar clicks en cualquier link de paginación
    blogSection.addEventListener('click', async function(e) {
      const link = e.target.closest('a');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      // Solo interceptar links de paginación (contienen ?page= o &page=)
      if (!href.includes('page=') && !link.closest('[class*="pagination"]')) return;

      // Prevenir navegación normal
      e.preventDefault();
      e.stopPropagation();

      // Mostrar indicador de carga
      const postsContainer = blogSection.querySelector('.ecom-shopify__blog--posts');
      if (postsContainer) {
        postsContainer.style.opacity = '0.4';
        postsContainer.style.pointerEvents = 'none';
        postsContainer.style.transition = 'opacity 0.3s ease';
      }

      try {
        // Hacer fetch de la nueva página
        const response = await fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const html = await response.text();

        // Parsear el HTML obtenido
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Buscar la nueva sección de blog en el HTML obtenido
        const newBlogSection = doc.querySelector('.ecom-shopify__blog');
        if (!newBlogSection) {
          console.warn('SUMA: no se encontró la nueva sección de blog');
          window.location.href = href; // fallback a navegación normal
          return;
        }

        // Extraer los nuevos posts y la nueva paginación
        const newPosts = newBlogSection.querySelector('.ecom-shopify__blog--posts');
        const newPagination = newBlogSection.querySelector('[class*="pagination"]');

        // Reemplazar contenido viejo por nuevo
        const currentPosts = blogSection.querySelector('.ecom-shopify__blog--posts');
        const currentPagination = blogSection.querySelector('[class*="pagination"]');

        if (newPosts && currentPosts) {
          currentPosts.innerHTML = newPosts.innerHTML;
        }
        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        }

        // Restaurar visibilidad
        if (postsContainer) {
          postsContainer.style.opacity = '1';
          postsContainer.style.pointerEvents = 'auto';
        }

        // Scroll suave hacia el inicio de la sección blog
        blogSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Actualizar la URL sin recargar (opcional)
        history.pushState({}, '', href);

      } catch (err) {
        console.error('SUMA: error en paginación AJAX', err);
        // Si algo falla, navegar normalmente
        window.location.href = href;
      }
    });
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogAjaxPagination);
  } else {
    initBlogAjaxPagination();
  }
})();